<template>
    <div id="app" v-if="$route.path !== '/pricing'" class="">
        <div id="nav" class=" mx-3 md:mx-12 ">
            <Navigation />
            <!-- <router-link to="/">Home2</router-link> |
            <router-link to="/about">About</router-link> -->
        </div>
        <main class="container mx-auto px-3 min-h-screen">
            <router-view/>
        </main>
        <Footer />
    </div>
    <div v-else class="border-8 bg-blue-900 border-blue-900 md:p-10"
        style="max-height: 80vh;">
        <router-view/>
    </div>
</template>

<script>
// import firebase from 'firebase/app';
// import 'firebase/auth';
import Navigation from '@/components/navigation/Navigation.vue';
import Footer from '@/components/navigation/Footer.vue';

export default {
    name: 'App',
    // metaInfo: {
    //   // if no subcomponents specify a metaInfo.title, this title will be used
    //   title: 'Fotografen einfach online buchen',
    //   // all titles will be injected into this template
    //   titleTemplate: '%s - Checkfoto',
    //   meta: [
    //     { charset: 'utf-8' },
    //     // { name: 'description', content: 'Tolle Fotografen seite für alle Kunden.' }
    //     ]
    // },
    components: {
        Navigation,
        Footer,
    },
    // computed: {
    //     logoutButton() {
    //         const { currentUser } = firebase.auth();
    //         // let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    //         return !currentUser;
    //     },
    // },
    // beforeCreate() {
    //     this.$store.commit('Customer/GET_CUSTOMER_ITEM');
    // },
    created() {
    },
    // methods: {
    //     logout() {
    //         firebase
    //             .auth()
    //             .signOut()
    //             .then(() => {
    //                 this.$router.replace('/login');
    //             });
    //     },
    // },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Baloo+Paaji+2:wght@400;600;700&display=swap');
#app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: 'Baloo Paaji 2', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// #nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>
